import { render, staticRenderFns } from "./AccountHolderExpenses.vue?vue&type=template&id=178f43a6&scoped=true"
import script from "./AccountHolderExpenses.vue?vue&type=script&lang=ts"
export * from "./AccountHolderExpenses.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderExpenses.vue?vue&type=style&index=0&id=178f43a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178f43a6",
  null
  
)

export default component.exports